export default __webpack_public_path__ + "static/6599-45820fcdf669e4bf3af185bee6f93d18.jpg";